const footerSX = {
    footerWrapper: (theme) => ({
        width: '100%',
        background: theme.palette.greyColors.main,
        borderTop: `1px solid ${theme.palette.secondary.contrastText}`,
        padding: theme.spacing(4.5, 0),
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(5.875, 0),
        },
    }),
    footerContainer: (theme) => ({
        maxWidth: 1104,
        padding: theme.spacing(0),
        margin: 'auto',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
        },
    }),
    newsletterSignup: (theme) => ({
        padding: theme.spacing(0, 2),
    }),
    mailingListTypography: (theme) => ({
        textTransform: 'uppercase',
        color: theme.palette.greyColors.dark,
        fontSize: theme.spacing(1.75),
        fontWeight: 400,
        letterSpacing: '3.11px',
        lineHeight: '18px',
        marginBottom: theme.spacing(1.5),
    }),
    mailingListText: (theme) => ({
        fontSize: theme.spacing(2.25),
        fontWeight: 300,
        display: 'block',
        letterSpacing: '0.9px',
        lineHeight: '32px',
        marginBottom: theme.spacing(1.5),
        [theme.breakpoints.down('sm')]: {
            fontSize: theme.spacing(1.75),
        },
    }),
    signupForm: {
        justifyContent: 'center',
        display: 'flex',
    },
    socialLinkGrid: (theme) => ({
        '& > a > svg': {
            fill: theme.palette.primary.main,
        },
    }),
    emailInputContainer: (theme) => ({
        marginRight: theme.spacing(1),
    }),
    emailInputRoot: (theme) => ({
        minWidth: 360,
        '& .Mui-error': {
            color: `${theme.palette.redColors.main} !important`,
            border: `2px solid ${theme.palette.redColors.main}`,
        },
        [theme.breakpoints.down('sm')]: {
            minWidth: 223,
        },
    }),
    emailInput: (theme) => ({
        backgroundColor: `${theme.palette.background.default} !important`,
        color: `${theme.palette.blueColors.main} !important`,
        border: `2px solid ${theme.palette.greyColors.light}`,
        borderRadius: theme.spacing(0.5),
        fontSize: theme.spacing(1.75),
        fontWeight: 400,
        fontFamily: 'system-ui, sans-serif',
        letterSpacing: '0.06em',
        lineHeight: 1,
        padding: theme.spacing(1.25),
        height: theme.spacing(2.75),
        WebkitBoxShadow: `0 0 0 100px ${theme.palette.background.default} inset !important`,
        WebkitTextFillColor: `${theme.palette.blueColors.main} !important`,
        '& .Mui-error': {
            color: `${theme.palette.redColors.main} !important`,
            border: `2px solid ${theme.palette.redColors.main}`,
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
        },
        '&::-webkit-input-placeholder': {
            color: `${theme.palette.blueColors.main} !important`,
            opacity: 1,
        },
    }),
    emailInputInvalid: (theme) => ({
        color: `${theme.palette.redColors.main} !important`,
        border: `2px solid ${theme.palette.redColors.main}`,
    }),
    emailLabel: (theme) => ({
        display: 'block',
        fontSize: theme.spacing(2),
        marginTop: theme.spacing(1.25),
        marginRight: 0,
        marginLeft: 0,
        lineHeight: 1,
        marginBottom: theme.spacing(1.25),
        color: theme.palette.redColors.main,
    }),
    subscribeButton: (theme) => ({
        background: theme.palette.primary.light,
        color: theme.palette.background.default,
        fontSize: theme.spacing(2),
        height: theme.spacing(5.625),
        position: 'relative',
        width: 144,
        textTransform: 'capitalize',
        cursor: 'pointer',
        transition: 'background-color .2s',
        '&:disabled': {
            color: `${theme.palette.background.default} !important`,
        },
        '&:hover': {
            backgroundColor: theme.palette.primary.contrastText,
        },
        '&:active': {
            backgroundColor: theme.palette.greyColors.contrastText,
        },
        [theme.breakpoints.down('sm')]: {
            left: 0,
        },
    }),
    subscribeButtonDoneIcon: (theme) => ({
        marginRight: theme.spacing(0.5),
    }),
    socialLinksContainer: (theme) => ({
        padding: theme.spacing(4, 2),
        '& > div': {
            padding: theme.spacing(0, 2.5),
            '& > a > svg': {
                fill: theme.palette.primary.main,
            },
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(3.5, 0),
            '& > div': {
                flexBasis: '14%',
                maxWidth: '14%',
                padding: theme.spacing(0, 1.5),
                '& > a > svg': {
                    height: theme.spacing(4),
                    width: theme.spacing(4),
                },
            },
        },
    }),
    footerNavigation: (theme) => ({
        padding: theme.spacing(0, 2),
        marginBottom: 10,
        display: 'grid',
        gridTemplateColumns: 'repeat(5,1fr)',
        gridColumnGap: '15px',
        '& > ul > li': {
            letterSpacing: '0.06em',
            marginBottom: '23px',
            textAlign: 'left',
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(0),
            gridTemplateColumns: 'repeat(1,1fr)',
            '& > ul': {
                borderBottom: `1px solid ${theme.palette.secondary.dark}`,
                marginBottom: theme.spacing(0),
                position: 'relative',
                width: '100%',
                '&.active': {
                    '& > li': {
                        display: 'block',
                        '& #panel-text': {
                            '&:after': {
                                transform: 'rotate(45deg) !important',
                            },
                        },
                    },
                },
                '& > li': {
                    display: 'none',
                    marginBottom: theme.spacing(2.5),
                    cursor: 'pointer',
                    '&:first-of-type': {
                        display: 'block',
                        padding: theme.spacing(2.875, 0),
                        marginBottom: theme.spacing(0),
                    },
                },
            },
        },
    }),
    footerNavigationTypography: (theme) => ({
        fontSize: theme.spacing(1.75),
        fontWeight: 400,
        letterSpacing: '3.11px',
        lineHeight: '18px',
        color: theme.palette.greyColors.dark,
        textTransform: 'uppercase',
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(0, 2),
            '&:after': {
                borderBottom: `4px solid ${theme.palette.secondary.dark}`,
                borderRight: `4px solid ${theme.palette.secondary.dark}`,
                content: '""',
                height: theme.spacing(1.25),
                position: 'absolute',
                right: theme.spacing(2),
                transform: 'rotate(-45deg)',
                width: theme.spacing(1.25),
            },
        },
    }),
    footerNavigationLink: (theme) => ({
        color: `${theme.palette.blueColors.main} !important`,
        fontSize: theme.spacing(2),
        fontWeight: 'bold',
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(0, 2),
        },
    }),
    copyRightText: (theme) => ({
        fontSize: theme.spacing(1.75),
        textAlign: 'center',
    }),
};
export default footerSX;
